import { createContext } from 'react';
import type { BrandingContextValue } from '../types/branding.types';
import { DEFAULT_BRANDING } from '../services/branding.service';

export const BrandingContext = createContext<BrandingContextValue>({
  branding: DEFAULT_BRANDING,
  isLoading: true,
  isCustomBranded: false,
  isNotFound: false,
});
